import { useEffect, useSyncExternalStore } from 'react';
import { powerCurveKey } from './powerCurveStore';
import { powerCurveStore } from './sharedPowerCurveStore';

// 팀 상세를 열 때 필요한 (캐릭터, 무기)의 파워 커브를 공유 저장소에서 받아 온다. 같은 조합은 화면(웹/PiP)이 몇 개든 한 번만 요청한다.
// entries: [{ characterName, weaponName }] — 반환: { [key]: { status: 'loading' | 'done' | 'error', points } }
export default function usePowerCurves(entries) {
  const curves = useSyncExternalStore(powerCurveStore.subscribe, powerCurveStore.getSnapshot);

  const signature = entries.map((e) => powerCurveKey(e.characterName, e.weaponName)).join(',');
  useEffect(() => {
    entries.forEach(({ characterName, weaponName }) => powerCurveStore.request(characterName, weaponName));
    // entries 내용이 바뀔 때만 (signature)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signature]);

  return curves;
}

export { powerCurveKey };
